import Jaco from "./Jaco";
import Jaco3d from "../arrangement3d/Jaco3d";

export default class LazyPool {

    usedLength = 0;
    /** @type {Jaco} */
    jaco;
    /** @type {Jaco[]} */
    array;
    jacoCreator;
    jaco3DCreator;
    numberOfCopies = 1;

    constructor(jaco, array, jacoCreator, jaco3DCreator = null, numberOfCopies = 1) {
        this.jaco = jaco;
        this.array = array;
        this.jacoCreator = jacoCreator;
        this.jaco3DCreator = jaco3DCreator;
        this.numberOfCopies = numberOfCopies;
    }

    get(i) {
        this.usedLength = Math.max(this.usedLength, i + 1);
        while (i + 1 > this.array.length) {
            this.array.push(this.jacoCreator());
        }
        const entry = this.array[i];
        if (this.jaco3DCreator) {
            this.jaco.lazyCreateOrTouch3d(this.jaco3DCreator(i));
        }
        return entry;
    }

    next() {
        return this.get(this.usedLength);
    }

    cleanup() {
        if (this.array.length > this.usedLength) {
            this.array.splice(this.usedLength, this.array.length - this.usedLength);
        }
    }

    findOrCreate(predicate) {
        if (this.numberOfCopies <= 1) {
            const i = this.array.findIndex(predicate);
            if (i >= 0 && i < this.usedLength) {
                return this.get(i);
            }
            return this.next();
        } else {
            const allMatching = this.array.filter(predicate);
            if (allMatching.length == 0) {
                return this.next();
            } else if (allMatching.length < this.numberOfCopies) {
                if (!allMatching[0].clone)
                    return this.next();
                const cloned = allMatching[0].clone();
                this.usedLength++;
                this.array.push(cloned);
                return cloned;
            }
            this.usedLength++;
            return _.sample(allMatching);
        }
    }

}
